// Mirrors User#fiscal_foreigner?: the fiscal address country wins over the home address one.
function isFiscalForeigner() {
  const homeCountry = $('#owner_home_address_attributes_country').val();
  const fiscalCountry = $('#owner_fiscal_address_attributes_country').val();
  const country = $('#owner_has_fiscal_address_true').is(':checked') && fiscalCountry ? fiscalCountry : homeCountry;

  return Boolean(country) && country !== 'FR';
}

function toggleForeignerTaxExemptionField() {
  $('.js-foreigner-tax-exemption-field').toggleClass('d-none', !isFiscalForeigner());
}

$(document).ready(() => {
  $('#owner_home_address_attributes_country, #owner_fiscal_address_attributes_country, .js-radio-fiscal-form')
    .on('change', toggleForeignerTaxExemptionField);
});
